import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { FormInput } from 'pages/checkout/components/common/input-styled-components';
import { StepWrapper } from 'pages/checkout/components/common/layout-styled-components';
import { BaseHeaderText } from 'pages/checkout/components/common/typographic-styled-components';

export const VerifyStepWrapper = styled(StepWrapper)`
  gap: 24px;
  align-items: stretch;
`;

interface CodeInputProps {
  $loading: boolean;
}

export const CodeInput = styled(FormInput)
  .attrs<CodeInputProps>(({ $loading }) => ({
    type: 'text',
    autoComplete: 'one-time-code',
    name: 'otp',
    'aria-label': 'Verification code',
    'data-1p-ignore': 'true',
    inputMode: 'numeric',
    autoFocus: true,
    maxLength: 4,
    disabled: $loading,
  }))`
    width: 100%;
    text-align: center;

    transition: opacity 0.2s ease-in-out;

  ${({ $loading }) => $loading && css`
    opacity: 0.5;
  `}
`;

export const ContactText = styled(BaseHeaderText)`
  color: ${BRAND_COLORS.darkGreen};
  font-size: 18px;
  line-height: 21px;
  text-align: center;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
